class LockWrapper {
  static LOCK_SCREENS = ['signin', 'forgot_password', 'signup'];

  constructor(config, options, lockClass) {
    this.config = config;
    this.options = options;
    this.lockClass = lockClass;
  }

  render(
    lockState,
    focusCallback,
    renderedCallback,
    forgotPasswordSubmittedCallback
  ) {
    this.destroyLockInstance();

    if (!lockState) {
      if (focusCallback) {
        focusCallback();
      }
      return;
    }

    this.createLockInstance(lockState);

    if (renderedCallback) {
      this.setupRenderedCallbacks(renderedCallback);
    }

    if (focusCallback) {
      this.setupFocusCallback(focusCallback);
    }

    if (
      lockState.lockOptionOverrides.initialScreen === 'forgotPassword' &&
      forgotPasswordSubmittedCallback
    ) {
      this.setupForgotPasswordCallback(forgotPasswordSubmittedCallback);
    }

    this.lockInstance.show(lockState.showOptions);
  }

  setupRenderedCallbacks(renderedCallback) {
    LockWrapper.LOCK_SCREENS.forEach((screenName) => {
      this.lockInstance.on(`${screenName} ready`, () =>
        renderedCallback(screenName)
      );
    });
  }

  setupFocusCallback(callback) {
    this.lockInstance.on('signup ready', () => callback());
    this.lockInstance.on('signin ready', () => callback());
  }

  setupForgotPasswordCallback(callback) {
    this.lockInstance.on('signin ready', callback);
  }

  destroyLockInstance() {
    this.lockInstance?.destroy();
  }

  createLockInstance(lockState) {
    this.lockInstance = new this.lockClass(
      this.config.clientID,
      this.config.auth0Domain,
      { ...this.options, ...lockState.lockOptionOverrides }
    );
  }
}

export default LockWrapper;
